import { render, staticRenderFns } from "./ProductPricingAccordion.vue?vue&type=template&id=37e85192&scoped=true&lang=pug&"
import script from "./ProductPricingAccordion.vue?vue&type=script&lang=js&"
export * from "./ProductPricingAccordion.vue?vue&type=script&lang=js&"
import style0 from "./ProductPricingAccordion.vue?vue&type=style&index=0&id=37e85192&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e85192",
  null
  
)

export default component.exports